<template>
  <div>
    <el-form inline :model="searchForm" :loading="searching">
      <el-form-item label="分组名称">
        <el-input placeholder="多个名称可以用逗号分割" v-model="searchForm.names" style="width: 20rem">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(0)" />
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
        <el-button @click="reset" icon="el-icon-refresh-right">重置</el-button>
      </el-form-item>
    </el-form>
    <el-row>
      <el-button icon="el-icon-plus" @click="addNewGroup">新增权限分组</el-button>
      <el-button icon="el-icon-delete" @click="deleteByItems">批量删除</el-button>
    </el-row>
    <el-table :data="list" style="margin-top: 1rem" border
              :header-cell-style="{background:'#eee',color:'black'}"
              max-height="600"
              ref="tableView"
    >
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       :fixed="item.flex"
                       v-if="item.type !== 3 && item.type !== 4 && item.type !== 5"
                       :type="item.typeText"
      >
      </el-table-column>
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       :fixed="'right'"
                       v-if="item.type === 3"
                       :type="item.typeText"
      >
        <template slot-scope="scope">
          <el-button v-for="(actionItem, actionIndex) in item.actions" :key="'btn_' + actionIndex" size="mini" :type="actionItem.btnType" @click="btnAction(actionItem, scope.row)">
            {{actionItem.title}}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 1rem"
                   :page-size.sync="pageSize"
                   :total.sync="totalCount"
                   :current-page.sync="curPage"
                   @size-change="search"
                   @current-change="search"
                   :page-sizes="[20, 100, 200, 500, 1000]"
                   layout="total, sizes, prev, pager, next, jumper"
    />
    <el-dialog title="批量操作" :visible.sync="showMultipleEditBox">
      <el-card shadow="never" style="flex-wrap: wrap; justify-content: space-around">
        <el-tag v-for="(tag, index) in tags" :key="index" closable style="margin: 0.2rem">
          {{tag}}
        </el-tag>
        <el-input ref="multipleInput" style="margin: 0.2rem; width: 120px" size="small" v-model="multipleEditName" placeholder="新增-回车保存" @keyup.enter.native="change"/>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="doneAction">确 定</el-button>
        <el-button @click="clearAction">清 除</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="showEditGroup" :title="editGroupTitle" width="50%">
      <add-permission-group :data="group" @success="groupAddOrEditSuccess"/>
    </el-dialog>
    <el-dialog :visible.sync="showMemberDialog" title="群组成员" width="70%">
      <permission-group-member :group-data="group"/>
    </el-dialog>
    <el-dialog :visible.sync="showAddMemberDialog" :title="'添加成员 (' + (group?group.name:'') + ')'" width="80%" height="80%" @close="search">
      <permission-group-member-edit :group-data="group" />
    </el-dialog>
    <el-dialog :visible.sync="showMenus" :destroy-on-close="true" :title="type === 0? '菜单权限':'功能点权限'" width="40%" height="80%">
      <permission-menu :key="'' + type + '_' + (group?group.groupId:'_')"
                       :menus="type === 0? permissionMetaData.menus: permissionMetaData.functions"
                       :group-data="group"
                       :type="type"
                       @close="showMenus=false"
                       @success="editSuccess"
      />
    </el-dialog>
  </div>
</template>

<script>
import {deletePermissionGroupByIds, permissionMeta, queryPermissionGroup} from './employeeApi'
import addPermissionGroup from './addPermissionGroup'
import PermissionGroupMember from './permissionGroupMember'
import PermissionGroupMemberEdit from './permissionGroupMemberEdit'
import {operationByPath} from '../sku/skuApi'
import {replaceText} from '../../libs/LinkUtil'
import PermissionMenu from './permissionMenu'
export default {
  name: 'permission',
  components: {PermissionMenu, PermissionGroupMemberEdit, PermissionGroupMember, addPermissionGroup},
  data () {
    return {
      searchForm: {
        names: '',
        remarks: ''
      },
      viewKey: -100000,
      searching: false,
      multipleEditBoxType: 0,
      tags: [],
      showMultipleEditBox: false,
      multipleEditName: '',
      showEditGroup: false,
      editGroupTitle: '新建分组',
      curPage: 1,
      totalCount: 0,
      totalPage: 0,
      pageSize: 20,
      list: [],
      listKeyMap: [],
      memberListKey: [],
      showMemberDialog: false,
      group: null,
      showAddMemberDialog: false,
      permissionMetaData: null,
      showMenus: false,
      showFunction: false,
      type: 0
    }
  },
  created () {
    this.search()
    this.requestPermissionMeta(null)
  },
  methods: {
    search () {
      this.searching = true
      queryPermissionGroup(this.searchForm).then(rsp => {
        this.searching = false
        const {code, message, result} = rsp
        if (code === 0) {
          const {pagination, values} = result
          const {list, curPage, pageSize, totalCount, totalPage} = pagination
          this.curPage = curPage
          this.pageSize = pageSize
          this.totalPage = totalPage
          this.totalCount = totalCount
          this.list = list
          this.listKeyMap = values
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.searching = false
      })
    },
    deleteByItems () {
      const items = this.$refs.tableView.selection
      if (items === undefined || items.length === 0) {
        this.$message.error('请选择需要删除的数据')
        return
      }
      const deleteAction = () => {
        const ids = []
        for (let i = 0; i < items.length; i++) {
          const tempItem = items[i]
          const {groupId} = tempItem
          ids.push(groupId)
        }
        deletePermissionGroupByIds({groupIds: ids}).then(rsp => {
          const {code, message} = rsp
          if (code === 0) {
            this.search()
            this.$message.success('操作成功')
          } else {
            this.$message.error(message)
          }
        })
      }
      this.$confirm('确定要删除这些权限分组吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(deleteAction).catch(null)
    },
    addNewGroup () {
      this.group = {name: '', remark: ''}
      this.showEditGroup = true
    },
    deleteItems () {

    },
    editSuccess () {
      this.showMenus = false
      this.group = {}
      this.search()
    },
    addMore (type) {
      this.multipleEditBoxType = type
      const key = this.keyForType(type)
      if (key === null) {
        return
      }
      const tempArray = this.searchForm[key].split(',')
      for (let i = tempArray.length - 1; i >= 0; i--) {
        const tempText = tempArray[i].trim()
        if (tempText.length === 0) {
          tempArray.splice(i, 1)
        }
      }
      this.tags = tempArray
      this.showMultipleEditBox = true
      setTimeout(() => {
        this.$refs.multipleInput.focus()
      }, 100)
    },
    keyForType (type) {
      let key = null
      if (type === 0) {
        key = 'names'
      } else if (type === 1) {
        key = 'names'
      } else if (type === 2) {
        key = 'contactPhones'
      } else if (type === 3) {
        key = 'contactNames'
      } else if (type === 4) {
        key = 'names'
      }
      return key
    },
    doneAction () {
      this.showMultipleEditBox = false
      const text = this.tags.join(',')
      const key = this.keyForType(this.multipleEditBoxType)
      this.searchForm[key] = text
    },
    clearAction () {
      this.tags = []
    },
    reset () {
      this.searchForm.names = ''
    },
    change () {
      const tempName = this.multipleEditName.trim()
      if (tempName.length === 0) {
        return
      }
      if (this.tags.indexOf(tempName) < 0) {
        this.tags.push(tempName)
      }
      this.multipleEditName = ''
      this.$refs.multipleInput.focus()
    },
    groupAddOrEditSuccess () {
      this.showEditGroup = false
      this.search()
    },
    closeAddOrEditCustomer () {
      this.showEditGroup = false
    },
    btnAction (action, item) {
      const {type} = action
      if (type === 0) {
        const {code} = action
        if (code === 'edit') {
          this.group = item
          this.editCustomerTitle = '编辑分组信息'
          this.showEditGroup = true
        } else if (code === 'member') {
          this.group = item
          this.showMemberDialog = true
        } else if (code === 'add') {
          this.group = item
          this.showAddMemberDialog = true
        } else if (code === 'menus') {
          this.group = item
          this.type = 0
          this.showMenus = true
        } else if (code === 'function') {
          this.group = item
          this.type = 1
          this.showMenus = true
        }
      } else if (type === 1) {
        const deleteAction = () => {
          let {actionLink} = action
          actionLink = replaceText(actionLink, item, true)
          operationByPath(actionLink).then(rsp => {
            const {code, message} = rsp
            if (code === 0) {
              this.search()
              this.$message.success('操作成功')
            } else {
              this.$message.error(message)
            }
          })
        }

        let {alertMsg} = action
        alertMsg = replaceText(alertMsg, item, false)
        this.$confirm(alertMsg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(deleteAction).catch(null)
      }
    },

    requestPermissionMeta (callback) {
      if (this.permissionMetaData != null) {
        callback && callback()
        return
      }
      permissionMeta().then(rsp => {
        this.searching = false
        const {code, message, result} = rsp
        if (code === 0) {
          this.permissionMetaData = result
          callback && callback()
        } else {
          this.$message.error(message)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/employee/permission.vue